import React, { useEffect, useState } from 'react';
import { useAppDispatch } from 'hooks';

import AppointmentDetails from '~weekly-planner/components/modal/AppointmentDetails';

import { openAppointmentDetails, openAppointmentRosteringNotes } from '~weekly-planner/reducers/weeklyPlanner';

import AppointmentRosteringNotes from '../modal/AppointmentRosteringNotes';

interface ComponentProps {
  appointment: any;
  openDetailsId: number | null;
  openRosteringNotesId: number | null;
  contextTarget: string;
  isDragging: boolean;
  isDashboardView?: boolean;
}

const AppointmentPopovers: React.FC<ComponentProps> = ({
  appointment,
  openDetailsId,
  openRosteringNotesId,
  contextTarget,
  isDashboardView,
  isDragging,
}) => {
  const [isDetailsOpen, setDetailsOpen] = useState(false);
  const [isRosteringNotesOpen, setRosteringNotesOpen] = useState(false);
  const dispatch = useAppDispatch();

  const resetPopovers = () => {
    dispatch(openAppointmentDetails(''));
    dispatch(openAppointmentRosteringNotes(''));
  };

  useEffect(() => {
    if (isDragging) {
      resetPopovers?.();
    }
  }, [isDragging, resetPopovers]);

  useEffect(() => {
    if (appointment.key === openDetailsId) {
      setDetailsOpen(true);
      setRosteringNotesOpen(false);
    } else if (appointment.key === openRosteringNotesId) {
      setDetailsOpen(false);
      setRosteringNotesOpen(true);
    } else {
      setDetailsOpen(false);
      setRosteringNotesOpen(false);
    }
  }, [
    appointment.key,
    appointment.id,
    appointment.parent_repeat_id,
    appointment.date,
    openDetailsId,
    openRosteringNotesId,
    isDragging,
  ]);

  return (
    <>
      <AppointmentDetails
        isOpen={isDetailsOpen}
        target={contextTarget}
        appointment={appointment}
        isDashboardView={isDashboardView}
      />
      <AppointmentRosteringNotes
        isOpen={isRosteringNotesOpen}
        target={contextTarget}
        appointment={appointment}
        toggle={resetPopovers}
      />
    </>
  );
};

export default AppointmentPopovers;
